export default __webpack_public_path__ + "static/media/content-deco-1.6d840217.webp";